var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { loaderPathStyle, loaderSvgStyle, svgWrapperStyle, containerStyle, wrapperStyle, } from './styles';
function Loader(_a) {
    var _b = _a.inverted, inverted = _b === void 0 ? false : _b, ariaLabel = _a["aria-label"], restProps = __rest(_a, ["inverted", 'aria-label']);
    var width = restProps.width, height = restProps.height;
    return (_jsx("div", __assign({ "data-testid": "loader-wrapper", css: wrapperStyle({ height: height, width: width }), role: "alert", "aria-label": ariaLabel }, { children: _jsx("div", __assign({ css: containerStyle() }, { children: _jsx("div", __assign({ css: svgWrapperStyle() }, { children: _jsx("svg", __assign({ viewBox: "0 0 2640 3444", css: loaderSvgStyle({ inverted: inverted }) }, restProps, { children: _jsx("path", { css: loaderPathStyle(), d: "M0 0 M2569 1056L143 2447V149l1175 673v1867l1248 715", fill: "none", strokeLinejoin: "round", strokeWidth: "300" }) })) })) })) })));
}
export default Loader;
